import { ReactElement } from 'react'
import styled, { useTheme } from 'styled-components'

const TextWrap = ({
  children,
  color,
}: {
  children: ReactElement
  color?: string
}) => {
  const theme = useTheme()
  return (
    <Container>
      <Background color={color}>{children}</Background>
      <Body>{children}</Body>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  width: calc(100% - 50px);
  max-width: 600px;
  margin: 0 auto;
`

const backgroundColor = (props: any) => {
  const defaultColor = `rgb(${props.theme.grayColorLight})`
  return props.color || defaultColor
}

const text = (props: any) => `
    font-size: 1.1em;
    line-height: 1.45;
    font-family: var(--font-serif);
    color: var(--font-color);
    display: inline;
    background-color: ${backgroundColor(props)};
    padding: 10px 0 11px 0;
    border-radius: 5px;
    box-shadow: 15px 0 ${backgroundColor(props)}, -15px 0 ${backgroundColor(
  props
)};
    box-decoration-break: clone;
`

const Background = styled.div`
  p {
    ${(props) => text(props)}
  }

  position: relative;
  z-index: -1;
  color: white;
`
const Body = styled.div`
  p {
    ${text}
    background-color: transparent;
    box-shadow: none;
  }
  position: absolute;
  top: 0;
`

export default TextWrap
